export const ENGLISH_LANG_CODE = 'en';
export const SPANISH_LANG_CODE = 'es';

export const GOOGLE_TRANSLATE_ELEMENT_ID = 'google_translate_element_script';
export const TRANSLATE_INIT_CALLBACK_NAME = 'translateInit';
